import { create } from 'zustand';
import type { GameState } from '@/types';

type GameStateUpdater =
  | Partial<GameState>
  | ((state: GameState) => Partial<GameState>);

export interface GameStore extends GameState {
  setGameState: (updater: GameStateUpdater) => void;
  resetGameState: () => void;
}

const defaultGameState: GameState = {
  currentScreen: 'auth',
  userProfile: null,
  currentPlayerState: null,
  isProfileLoading: false,
  selectedCartridge: null,
  currentRoom: null,
  isMultiplayer: false,
  isLoading: false,
  isLoadingChat: false,
  isLoadingAppearance: false,
  isListening: false,
  microphoneError: null,
  error: null,
  apiKeyStatus: 'unknown',
  chatMessages: [],
  currentStorySegment: null,
  currentSessionId: null,
  sessionId: null,
  roomCode: undefined,
  preCombatState: undefined,
  currentInstanceId: null,
};

export const useGameStore = create<GameStore>((set) => ({
  ...defaultGameState,
  setGameState: (updater) =>
    set((state) => {
      const partial =
        typeof updater === 'function' ? updater(state) : updater;
      return { ...state, ...partial };
    }),
  resetGameState: () =>
    set((state) => ({
      ...state,
      ...defaultGameState,
    })),
}));
